import React from "react";
import "./BreadcrumbHeading.scss";
import { IoIosArrowBack } from "react-icons/io";
import { CgFormatSlash } from "react-icons/cg";
import { NavLink } from "react-router-dom";

const BreadcrumbHeading = ({
  dataTableHeadingText,
  dataTablePageLink,
  pageNumber,
  onClickEvent,
  navigationState,
  disableLastLink = false,
}) => {
  let title = Array.isArray(dataTableHeadingText)
    ? dataTableHeadingText
    : [dataTableHeadingText];
  let links = Array.isArray(dataTablePageLink)
    ? dataTablePageLink
    : [dataTablePageLink];
  let states = Array.isArray(navigationState)
    ? navigationState
    : navigationState
    ? [navigationState]
    : [];

  const breadcrumbItems = title.map((text, index) => ({
    title: text,
    link: links[index],
  }));
  return (
    <div>
      <div className="d-flex flex-row justify-content-start align-items-center  rdt_heading_container">
        {pageNumber === 1 ? (
          title.map((titles, index) => (
            <NavLink
              key={index}
              to={!onClickEvent && links[index] && links[index]}
              onClick={onClickEvent}
              className="d-flex align-items-center text-decoration-none mt-2"
            >
              <IoIosArrowBack style={{ height: "12px", width: "20px" }} />

              <h2 className="pe-2 main-heading-breadcrumb">{titles}</h2>
            </NavLink>
          ))
        ) : (
          <div>
            <div className="d-flex flex-row justify-content-start align-items-center rdt_heading_container ff-poppins fs-24px ms-2">
              {title.map((titles, index) => (
                <NavLink
                  key={index}
                  to={!onClickEvent && links[index] && links[index]}
                  state={
                    states[index] !== undefined ? states[index] : undefined
                  }
                  style={index === title.length - 1 && disableLastLink ? { pointerEvents: 'none' } : {}}
                  className="d-flex align-items-center text-decoration-none"
                >
                  {index > 0 && (
                    <CgFormatSlash className="breadcrumbs_seperator" />
                  )}

                  <h2
                    className="breadcrumb-main-heading"
                    style={
                      index === title.length - 1 ? { color: "#808080" } : {}
                    }
                  >
                    {titles}
                  </h2>
                </NavLink>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BreadcrumbHeading;
